import { CMSService, ObservationService } from 'client/services';
import { redirect } from 'react-router';
import { MAP_PAGE } from 'client/utils/routes/routeConstants';

const loader = async ({ params }) => {
    const { observationId } = params;
    if (!observationId) {
        return redirect(MAP_PAGE);
    }

    const [
        disclaimerContent,
        observation
    ] = await Promise.all([
        CMSService.getObservationsDisclaimer(),
        ObservationService.getObservation(observationId)
    ]);

    return { disclaimerContent, observation };
};

export default loader;
